import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jsmBoardRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
	name: 'servicedesk-boards',
	exact: true,
};
